import styled from 'styled-components';
import { colorCSS, breakpoints } from '../../styles';
export const NavLinkAnchor = styled.a `
  display: block;
  padding: 1rem;
  text-align: left;
  text-decoration: none;

  ${({ hoverColorInitial }) => hoverColorInitial &&
    `
  &:active {
    background-color: ${colorCSS(`${hoverColorInitial}50`, 0.5)};
  }
  
  &:focus:focus-visible {
    background-color: ${colorCSS(`${hoverColorInitial}50`, 0.5)};
  }

  @media (min-width: ${breakpoints.lg}px) {
    &:hover {
      background-color: ${colorCSS(`${hoverColorInitial}50`, 0.5)};
      transition: background-color 0.3s ease;
    }
  }
  `}
`;
export const NavIcon = styled.div `
  svg {
    path,
    rect {
      fill: ${({ iconColorInitial }) => iconColorInitial
    ? colorCSS(`${iconColorInitial}100`)
    : colorCSS(`N100`)};
    }
    height: 1.2rem;
    width: auto;
  }
  padding: 0.14rem 0.71rem 0 0.15rem;
`;
export const NavLinkTitleContainer = styled.div `
  display: flex;
  line-height: 1rem;
  padding-bottom: 0.6rem;
`;
export const NavLinkTitle = styled.p `
  color: ${colorCSS('N800')};
  font-family: 'Charlie Text';
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.5rem;
  margin: 0 !important;
  padding-right: 0.3rem;
`;
export const NavLinkDescription = styled.div `
  p {
    color: ${colorCSS('N400')};
    font-size: 0.75rem;
    line-height: 1rem;
    margin: 0 !important;
  }
`;
//# sourceMappingURL=UiNavLink.styles.js.map